import { render, staticRenderFns } from "./WaitingTable.vue?vue&type=template&id=d8b7b38a&"
import script from "./WaitingTable.vue?vue&type=script&lang=js&"
export * from "./WaitingTable.vue?vue&type=script&lang=js&"
import style0 from "./WaitingTable.vue?vue&type=style&index=0&id=d8b7b38a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports